import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import roomCh4 from '../assets/imgs/rooms-ch4.png';

class Chapter3 extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-title">INFECTED</div>
                        <div className="Room-img">
                            <img src={roomCh4} width={350} alt="" />
                        </div>
                        <div className="Room-description">
                            <div className="text">
                                On your continued journey to the United Human Compound, you stumble upon an abandoned doctor's lab. Medical supplies are hard to come by so you decide to go in and search for anything of value. But soon you find yourself fighting for your life, battling a deadly virus. You must find a cure before it's too late. Your time is ticking.
                                <p>This game involves a live actor.</p>
                            </div>
                            <div className="table-container">
                                <div className="table-row">
                                    <div className="table-label">MISSION</div>
                                    <div className="table-text">
                                        Find a cure before it's too late.
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">TIME</div>
                                    <div className="table-text">50 min</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">PLAYERS</div>
                                    <div className="table-text">Min 2, Max 6</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">DIFFICULTY</div>
                                    <div className="table-text">
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="note">
                                * If you desire to book a specific game that is not reflected on our
                                Ticket Schedule please contact us for further availability. <br />*
                                You can swap Chapters. If for a desired time slot you would prefer
                                to do another Chapter
                                <br /> that is originally offered on our Ticketing Site, please
                                contact us to swap for your preferred Chapter.
                            </div>
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Chapter3;
